// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__jtiTQ","signatureBlock":"Footer_signatureBlock__1ajnU","signature":"Footer_signature__2wF7f"};